

export const isInteger = {
    name: "isInteger",
    validate: (value) => !value || (!isNaN(value) && +value % 1 === 0 ),
};
